import { IListaBandeiras } from './../../shared/bandeira-cartao';
import { Bandeiras, environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PagamentoService } from 'src/app/services/pagamento.service';
import { CartoesTipoRegex } from 'src/app/utils/cartoes-tipo-regex';
import { delegate } from 'utils-decorators';
import { FormaCobrancaEnum } from 'src/app/shared/enums/forma-cobranca.enum';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { BandeiraCartao } from 'src/app/shared/bandeira-cartao';
import { HomeService } from './home.service';
import { DateValidator } from 'src/app/shared/data-validator';
import { ExternalAuthenticationData } from 'src/app/data/pagamento/external-authentication.data';
import { CartaoCreditoData } from 'src/app/data/pagamento/cartao-credito.data';
import { ConsultaPagamento } from 'src/app/models/consulta/consulta-pagamento.model';
import { CobrancaData } from 'src/app/data/pagamento/cobranca.data';
import { Subject } from 'rxjs';
import { format } from 'date-fns';
import { formatCpfCnpj, formatCurrency } from 'src/app/utils/util';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  bandeiras: BandeiraCartao[] = [];
  // bandeirasPermitidas: BandeiraCartao[] = [];

  token!: string;
  numeroCartao?: any;
  exibirConteudo = false;
  consultaPagamento?: ConsultaPagamento;
  descricaoFormaCobranca?: string;
  idFormaCobranca?: number;
  bandeiraSelecionada?: BandeiraCartao;
  listaParcelas: any[] = [];

  // listaBandeiras: IListaBandeiras[] | null = null;


  constructor(
    private activatedRoute: ActivatedRoute,
    private pagamentoService: PagamentoService,
    private homeService: HomeService,
    private spinner: NgxSpinnerService,
    public router: Router
  ) {
    this.pagamentoForm.controls.numeroCartao.valueChanges.subscribe(numeroCartao => { this.onNumeroCartaoChange(numeroCartao!.toString()) });
    this.bandeiras = Bandeiras
  }


  ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParams?.token;
    this.token?.length === undefined || this.token.length === 0 ? this.carregarlinkStatus(1) : this.consultarPagamento(this.token);
    // this.listaBandeiras = listaBandeiras
  }

  public pagamentoForm = new FormGroup({

    titularCartao: new FormControl('', [Validators.required]),
    numeroCartao: new FormControl<string | null>(null, [Validators.required]),
    dataValidade: new FormControl<string | null>(null, [Validators.required, DateValidator.dateValidator]),
    cvv: new FormControl('', [Validators.required, Validators.pattern(/[0-9]/)]),
    valorTotal: new FormControl<string | null>(null, [Validators.required]),
    valorParcelaCartao: new FormControl<string | null>(null, [Validators.required]),
    numeroParcelasCartao: new FormControl<string | null>(null, [Validators.required]),
    bandeiraCartaoCredito: new FormControl<string | null>(null),
    valorTotalParceladoCartao: new FormControl<string | null>(null, [Validators.required])
  });

  @delegate()
  async consultarPagamento(token: string) {

    this.showLoading();

    try {
      let response = await this.pagamentoService.consultarPagamento(token);

      this.consultaPagamento = new ConsultaPagamento(response);
      this.idFormaCobranca = this.consultaPagamento.idFormaCobranca;
      this.obterFormaCobranca(this.consultaPagamento.idFormaCobranca);
      // this.carregarLogoCartao(this.bandeirasPermitidas);

    }
    catch (error: any) {
      this.carregarlinkStatus(error.error.mensagem == 'Venda ja paga' ? 3 : 1);

    }
    finally {
      setTimeout(() => {
        this.exibirConteudo = true;
        this.spinner.hide();
      }, 2000);
    }
  }

  @delegate()
  async confirmarPagamento() {

    this.showLoading();

    try {

      const form = this.pagamentoForm.value;
      const dataValidade = form.dataValidade;

      const externalAuthentication = new ExternalAuthenticationData({
        cavv: "",
        xid: "",
        eci: "",
        version: "",
        referenceID: ""
      })

      const cartaoCredito = new CartaoCreditoData({
        nome: form.titularCartao!,
        numero: form.numeroCartao!,
        bandeira: this.bandeiraSelecionada!.alt,
        mesValidade: dataValidade!.substring(0, 2),
        anoValidade: '20' + dataValidade!.substring(2),
        cvv: form.cvv!,
        valorParcelaCartao: Number(form.valorParcelaCartao!),
        numeroParcelasCartao: Number(form.numeroParcelasCartao!),
        bandeiraCartaoCredito: this.bandeiraSelecionada!.alt,
        valorTotalParceladoCartao: Number(form.valorTotalParceladoCartao!),
        externalAuthentication: externalAuthentication!
      })

      const cobranca = new CobrancaData({
        idFormaCobranca: this.idFormaCobranca!,
        cartaoCredito: cartaoCredito
      })

      const payload: any = { cobranca };

      this.homeService.body = {
        dataPagamento: this.formatarData(new Date(), "dd/MM/yyyy - HH:mm:ss"),
        valorGarantia: 'R$' + formatCurrency(this.consultaPagamento!.valorTotal),
        numeroGarantia: this.consultaPagamento!.numeroGarantia,
        dadosTitular: this.consultaPagamento?.subscritor,
        cpfCnpj: formatCpfCnpj(this.consultaPagamento!.cpfCnpjSubscritor, this.consultaPagamento!.tipoPessoa),
        formaCobranca: this.descricaoFormaCobranca,
        valorPagamento: `${cobranca.cartaoCredito.numeroParcelasCartao + 'x R$' + formatCurrency(cobranca.cartaoCredito.valorParcelaCartao) + ' - Total: R$' + formatCurrency(cobranca.cartaoCredito.valorTotalParceladoCartao)}`,
        bandeiraCartao: cobranca.cartaoCredito.bandeiraCartaoCredito,
        tipoPessoa: this.consultaPagamento!.tipoPessoa
      }

      this.showLoading();

      const response = await this.pagamentoService.realizarPagamento(payload, this.token);      

      this.carregarlinkStatus(2);

    } catch (err) {
      this.spinner.hide();
      this.infoPagamento();


    } finally {

    }
  }

  validarValidadeCartao(): any {

    return (control: AbstractControl) => {
      const length = control.value.split("/").join("").length;

      if (length < 6) {
        return {
          validacaoValidadeCartao: true,
        };
      }
      return null;
    };
  }

  validarBandeiraCartao(event: any): boolean {

    this.numeroCartao = event.target.value.replace(/\s+/g, '');
    if (this.pagamentoForm) {
      return this.obterBandeiraCartao() === "" && this.numeroCartao >= 14 ? true : false;
    }
    // this.onNumeroCartaoChange(this.numeroCartao)
    return true;
  }

  obterBandeiraCartao(): string {

    let tipoCartao = CartoesTipoRegex.obterBandeira(Number(this.numeroCartao));
    tipoCartao === CartoesTipoRegex.Discover ? (tipoCartao = CartoesTipoRegex.Elo) : "";

    this.bandeiraSelecionada = this.bandeiras.find(bandeira => bandeira.alt === tipoCartao?.nome);

    return (tipoCartao !== null || tipoCartao !== undefined) && this.bandeiraSelecionada?.alt !== undefined ? tipoCartao?.nome : "";
  }

  obterFormaCobranca(idFormaCobranca: number) {

    for (const FormaCobranca in FormaCobrancaEnum) {
      if (isNaN(Number(FormaCobranca))) {
        if (Number(FormaCobrancaEnum[FormaCobranca]) == idFormaCobranca) this.descricaoFormaCobranca = FormaCobranca;
      }
    }
  }

  // carregarLogoCartao(lista: BandeiraCartao[]) {

  //   lista.forEach(item => {
  //     const logomarca = Bandeiras.find(bandeira => bandeira.alt === item);
  //     if (logomarca) this.bandeiras.push(logomarca);
  //   });
  // }

  infoPagamento() {
    Swal.fire({
      iconHtml: '<i class="fa fa-times-circle"></i>',
      html: '<span class="teste">Ops! Ocorreu um problema com seu pagamento. Verifique as informações e tente novamente!</span>',
      confirmButtonText: 'OK',
      buttonsStyling: false,
      heightAuto: false,
    })
  }

  carregarlinkStatus(code: number) {
    this.homeService!.code = code;
    this.router.navigate(['status']);
  }

  showLoading() {
    this.spinner.show(undefined, {
      type: 'ball-clip-rotate',
      color: "#ffce00",
      bdColor: 'white',
      size: 'large',
      fullScreen: true,
    });
  }

  async getParcelas(
    idCartao: string,
    codConvenio: number,
    valorVenda: number
  ) {
    this.limpaFormaPagamento();
    this.showLoading();
    try {
      await this.pagamentoService.consultaParcelas({
        idCartao,
        codConvenio,
        valorVenda
      }, this.token).then(data => this.listaParcelas = data.retorno);
    } catch (error) {
      console.error(error);
    } finally {
      this.spinner.hide();
    }
  }

  dadosParcela(value: any) {
    const item = this.listaParcelas?.find(
      opcao => opcao.qtdParcelamento === parseInt(value));

    if (item) {
      this.pagamentoForm.patchValue({
        valorTotal: this.consultaPagamento!.valorTotal.toString(),
        valorParcelaCartao: item.valorParcela,
        numeroParcelasCartao: item.qtdParcelamento,
        valorTotalParceladoCartao: item.valorTotal
      });
    }
  }

  async onNumeroCartaoChange(numeroCartao: string) {
    this.limpaFormaPagamento();

    if (numeroCartao.length === 16) {

      let tipoCartao = CartoesTipoRegex.obterBandeira(Number(numeroCartao));
      tipoCartao === CartoesTipoRegex.Discover ? (tipoCartao = CartoesTipoRegex.Elo) : "";

      let bandeiraSelecionada = this.bandeiras.find(bandeira => bandeira.alt === tipoCartao?.nome);

      await this.getParcelas(
        bandeiraSelecionada!.id,
        environment.codConvenio,
        this.consultaPagamento!.valorTotal
      )

    }
  }

  limpaFormaPagamento() {
    this.listaParcelas = [];
    this.pagamentoForm.controls.valorParcelaCartao.setValue(null);
    this.pagamentoForm.controls.numeroParcelasCartao.setValue(null);
    this.pagamentoForm.controls.valorTotalParceladoCartao.setValue(null);
  }

  formatarData(data: Date, formato: string): string {
    return format(data, formato);
  }

}

